import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import TopNav from './TopNav';

/**
 * Layout for legal / public-info pages (Terms, Privacy, Refund, Contact).
 * Uses the shared TopNav so nav is identical across the landing, pricing,
 * and legal pages. Footer keeps the legal-entity disclosure required for
 * Razorpay compliance.
 */
export default function LegalLayout({ title, lastUpdated, children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f8faff',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      color: '#0f172a',
    }}>

      <TopNav />

      {/* Main content */}
      <main style={{
        maxWidth: '780px',
        margin: '2.5rem auto',
        padding: '0 1.5rem 4rem',
      }}>
        <h1 style={{
          fontFamily: "'Syne', sans-serif",
          fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
          fontWeight: 800,
          color: '#0f172a',
          letterSpacing: '-0.03em',
          margin: '0 0 0.5rem',
        }}>{title}</h1>
        {lastUpdated && (
          <p style={{ color: '#94a3b8', fontSize: '.9rem', margin: '0 0 2rem' }}>
            Last updated: {lastUpdated}
          </p>
        )}

        <div className="legal-prose" style={{
          background: 'white',
          borderRadius: '16px',
          padding: '2rem 2.25rem',
          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
          border: '1px solid #f1f5f9',
          lineHeight: 1.7,
          fontSize: '0.95rem',
        }}>
          <style>{`
            .legal-prose h2 {
              font-family: 'Syne', sans-serif;
              font-size: 1.25rem;
              font-weight: 800;
              color: #0f172a;
              margin: 2rem 0 0.75rem;
              letterSpacing: -0.01em;
            }
            .legal-prose h2:first-child { margin-top: 0; }
            .legal-prose h3 {
              font-size: 1rem;
              font-weight: 700;
              color: #1f2937;
              margin: 1.25rem 0 0.5rem;
            }
            .legal-prose p, .legal-prose li {
              color: #374151;
            }
            .legal-prose ul, .legal-prose ol {
              padding-left: 1.5rem;
              margin: 0.75rem 0;
            }
            .legal-prose li { margin-bottom: 0.35rem; }
            .legal-prose a {
              color: #6366f1;
              text-decoration: underline;
              text-decoration-color: rgba(99,102,241,0.25);
              text-underline-offset: 2px;
            }
            .legal-prose a:hover { text-decoration-color: rgba(99,102,241,0.7); }
            .legal-prose strong { color: #0f172a; }
          `}</style>
          {children}
        </div>
      </main>

      {/* Legal footer — keeps the entity disclosure required for Razorpay */}
      <footer style={{
        background: 'white',
        borderTop: '1px solid #f1f5f9',
        padding: '2rem',
        textAlign: 'center',
      }}>
        <div style={{ display: 'flex', gap: '1.25rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '1rem' }}>
          <Link to="/terms"   style={footerLink}>Terms of Service</Link>
          <Link to="/privacy" style={footerLink}>Privacy Policy</Link>
          <Link to="/refund"  style={footerLink}>Refund Policy</Link>
          <Link to="/contact" style={footerLink}>Contact</Link>
        </div>
        <p style={{ color: '#94a3b8', fontSize: '.8rem', margin: 0 }}>
          © {new Date().getFullYear()} Tambe Technologies (operating CreatorKhata) · Proprietor: Raju Tambe · Bangalore, Karnataka, India
        </p>
      </footer>
    </div>
  );
}

const footerLink = {
  fontSize: '.85rem',
  fontWeight: 600,
  color: '#475569',
  textDecoration: 'none',
};
